import {Pipe, PipeTransform} from '@angular/core';
import {ConversionsService} from '@shared/utils/conversions.service';

@Pipe({
    name: 'millisToMinutes'
})
export class MillisToMinutesPipe implements PipeTransform {

    constructor(private conversionsService: ConversionsService) {
    }

    transform(value: number): string {
        return this.conversionsService.getMinutesFromMillis(value);
    }
}
